export const PUSH_GTM_EVENT_START = 'PUSH_GTM_EVENT_START';

export const GTM_EVENTS = {
    DEPOSIT_CREATED: 'deposit_created',
    DEPOSIT_COMPLETED: 'deposit_completed',
    POSITION_OPENED_DEMO: 'position_opened_demo',
    SELECT_ACCOUNT_LIVE: 'select_account_live',
    SIGN_UP_COMPLETED: 'sign_up_completed',
} as const;
